export default __webpack_public_path__ + "static/media/inactive-diet.cab1742b.svg";